<template>
	<div class="verdict" :class="tone"><span class="ic"><i class="fa-solid" :class="icon"></i></span><div><b v-if="title">{{ title }}</b>{{ text }}</div></div>
</template>

<script>
const ICONS = { ok: 'fa-check', warn: 'fa-exclamation', info: 'fa-info' }

export default {
	name: 'PeVerdict',
	props: {
		tone: { type: String, default: 'info' }, // ok, warn, info
		title: { type: String, default: '' },
		text: { type: String, default: '' },
	},
	computed: {
		icon() { return ICONS[this.tone] || ICONS.info },
	},
}
</script>
